import { useQuery } from "@tanstack/react-query";
import queryKeys from "../configs/react-query/query-key";
import { apiBase } from "../apis";

export default function useVulnerabilityPolicy() {
  const fetchVulnerabilityPolicies = async () => {
    return apiBase({ url: queryKeys.vulnerabilityPolicy, method: "GET" });
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [queryKeys.vulnerabilityPolicy],
    queryFn: fetchVulnerabilityPolicies,
  });

  const vulnerabilityLevel = data?.vulnerabilityPolicies || [];

  return { vulnerabilityLevel, loading: isLoading, error: isError, refresh: refetch };
}
